import React from "react";
import PropTypes from "prop-types";
import Container from "@material-ui/core/Container";
import Box from "@material-ui/core/Box";
import Typography from "@material-ui/core/Typography";
import { withStyles } from "@material-ui/styles";
import Logo from "images/LivingSpaceLogoWhite-1.svg";
import { ButtonOutlineLight, ButtonOutlineLightExternal } from "components/ui";
import linkResolver from "utils/linkResolver";

import FacebookIcon from "@material-ui/icons/Facebook";
import InstagramIcon from "@material-ui/icons/Instagram";
import LinkedInIcon from "@material-ui/icons/LinkedIn";

const styles = theme => ({
  uppercase: {
    textTransform: "uppercase"
  },
  bgImageWrapper: {
    width: "100%",
    display: "flex",
    justifyContent: "space-evenly",
    flexDirection: "column",
    alignItems: "center",
    minHeight: "400px",
    padding: "40px 0px",
    height: "auto",
    [theme.breakpoints.up("lg")]: {
      height: "calc(100vh - 6vw)"
    }
  },
  indent: {
    width: "30px",
    [theme.breakpoints.up("lg")]: {
      width: "50px"
    }
  },
  logo: {
    width: "150px",
    [theme.breakpoints.up("lg")]: {
      width: "150px"
    }
  },
  socialicon: {
    color: theme.palette.text.white,
    fontSize: "2.5rem",
    transition: "color 0.3s ease-in-out",
    "&:hover": {
      color: theme.palette.text.light
    }
  }
});

function LargeImageBlock(props) {
  const { data, classes } = props;
  return (
    <Container maxWidth={false}>
      <div
        className={classes.bgImageWrapper}
        style={{
          backgroundImage: `url(${data.image.url})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          position: "relative", // ensure relative context
          overflow: "hidden"
        }}
      >
        {/* Color overlay positioned absolutely inside the bgImageWrapper */}
        <div
          style={{
            position: "absolute",
            top: 0,
            left: 0,
            backgroundColor: "#000",
            opacity: 0.45,
            width: "100%",
            height: "100%",
            pointerEvents: "none" // so it doesn't interfere with interactions
          }}
        />

        {/* Content goes above the overlay */}
        <div style={{ position: "relative", zIndex: 1 }}>
          <Box
            mb={2}
            display="flex"
            justifyContent="center"
            alignItems="center"
            flexDirection="column"
          >
            {data.show_logo_text && <Logo className={classes.logo} />}
          </Box>
          <Box>
            {data.title && (
              <Typography
                component="p"
                variant="h2"
                align="center"
                color="secondary"
                className={classes.uppercase}
              >
                {data.title[0].text}
              </Typography>
            )}
            {data.show_social_icons && (
              <Box
                display="flex"
                flexDirection="row"
                alignItems="center"
                justifyContent="center"
                mt={4}
              >
                <Box>
                  <a
                    href="https://www.facebook.com/LivingSpaceHousing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <FacebookIcon className={classes.socialicon} />
                  </a>
                </Box>
                <Box px={2}>
                  <a
                    href="https://www.instagram.com/livingspacehousing"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <InstagramIcon className={classes.socialicon} />
                  </a>
                </Box>
                <Box>
                  <a
                    href="https://www.linkedin.com/company/living-space-housing/"
                    target="_blank"
                    rel="noopener noreferrer"
                  >
                    <LinkedInIcon className={classes.socialicon} />
                  </a>
                </Box>
              </Box>
            )}
          </Box>
        </div>

        <div style={{ position: "relative", zIndex: 1 }}>
          {data.link && (
            <>
              {data.link_title &&
                data.link.__typename !== "PRISMIC__ExternalLink" && (
                  <ButtonOutlineLight
                    text={data.link_title[0].text}
                    link={`${data.link ? linkResolver(data.link._meta) : "/"}`}
                  />
                )}
              {data.link_title &&
                data.link.__typename === "PRISMIC__ExternalLink" && (
                  <ButtonOutlineLightExternal
                    text={data.link_title[0].text}
                    link={`${data.link.url ? data.link.url : "/"}`}
                  />
                )}
            </>
          )}
        </div>
      </div>
    </Container>
  );
}

LargeImageBlock.propTypes = {
  classes: PropTypes.object,
  data: PropTypes.object.isRequired
};

export default withStyles(styles)(LargeImageBlock);
